export default __webpack_public_path__ + "static/media/thunder64.a35e2c54.png";